module.exports = __webpack_public_path__ + "static/media/pijnkoorts.9a6ef7b5.svg";